import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
  	snackbar:{text:null,show:false},
  	routes:null,
  	cars:null,
  	places:null,
  	searchtext:null,
  	dateNow:null,
  	sortby:'country',
  	allcars:null,
  	},
  mutations: {},
  actions: {}
})
